import type { Menu } from '@/features/menus';

export function getDaysInMonth(date: Date): (Date | null)[] {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  // Add empty slots for days before the first day of the month
  const emptySlots = Array.from({ length: firstDay.getDay() }, () => null);

  // Add all days of the month
  const monthDays = Array.from(
    { length: lastDay.getDate() },
    (_, i) => new Date(year, month, i + 1)
  );

  return [...emptySlots, ...monthDays];
}

export function getMenusForDate(menus: Menu[], date: Date): Menu[] {
  const dateStr = date.toISOString().split('T')[0];
  return menus.filter((menu) => {
    const schedule = menu.schedule?.find((s) => s.date === dateStr);
    return schedule !== undefined;
  });
}

export function getPaxForDate(
  menus: Menu[],
  date: Date,
  forecastPax: Record<string, number>
): number {
  const dateStr = date.toISOString().split('T')[0];
  return menus.reduce((total, menu) => {
    const schedule = menu.schedule?.find((s) => s.date === dateStr);
    if (schedule) {
      return total + (forecastPax[`${menu.menuId}-${dateStr}`] ?? schedule.expectedPax);
    }
    return total;
  }, 0);
}

export function formatDateForDisplay(date: Date): string {
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric' 
  });
}
